import { FileDirectoryOpenFillIcon, GearIcon, StarIcon, TasklistIcon } from "@primer/octicons-react";
import { Box, UnderlineNav } from "@primer/react";
import { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NguonBietToiPage from "../crm-category/dm_nguonbiettoi";

import CaAnPage from "./ca-an";
import DangKyCaAnPage from "./dang-ky-ca-an";
import DangKyMonAnPage from "./dang-ky-mon-an";
import ThucDonPage from "./danh-sach-thuc-don";

const FoThucDonLayout = () => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const selectedTab = useMemo(() => {
    if (tab === "ca-an") return "ca-an";
    if (tab === "ca-an-truong") return "ca-an-truong";
    if (tab === "monan-chitiet") return "monan-chitiet";
    return "thuc-don";
  }, [tab]);
  return (
    <Box>
      <UnderlineNav aria-label="tabs">
        <UnderlineNav.Item
          icon={TasklistIcon }
          aria-current={selectedTab === "thuc-don" ? "page" : undefined}
          onClick={() => {
            navigate(`../../food/thucdon`);
          }}
        >
          Thực đơn
        </UnderlineNav.Item>
        <UnderlineNav.Item
          icon={FileDirectoryOpenFillIcon    }
          aria-current={selectedTab === "ca-an" ? "page" : undefined}
          onClick={() => {
            navigate(`../../food/ca-an`);
          }}
        >
          Ca ăn
        </UnderlineNav.Item>
        <UnderlineNav.Item
          icon={FileDirectoryOpenFillIcon    }
          aria-current={selectedTab === "ca-an-truong" ? "page" : undefined}
          onClick={() => {
            navigate(`../../food/ca-an-truong`);
          }}
        >
          Ca ăn - Trường
        </UnderlineNav.Item>
        <UnderlineNav.Item
          icon={FileDirectoryOpenFillIcon    }
          aria-current={selectedTab === "monan-chitiet" ? "page" : undefined}
          onClick={() => {
            navigate(`../../food/monan-chitiet`);
          }}
        >
          Món ăn
        </UnderlineNav.Item>       
      </UnderlineNav>
      <Box>{selectedTab === "thuc-don" && <ThucDonPage />}</Box>
      <Box>{selectedTab === "ca-an" && <CaAnPage />}</Box>
      <Box>{selectedTab === "ca-an-truong" && <DangKyCaAnPage />}</Box>
      <Box>{selectedTab === "monan-chitiet" && <DangKyMonAnPage />}</Box>

    </Box>
  );
};

export default FoThucDonLayout;
